<div class="wrapper">
    <div class="container-fluid p-0">
        <app-header *ngIf="!showExternalHeader"></app-header>
<!--       <app-header *ngIf="!showExternalHeader; else externalHeader"></app-header>
         <ng-template #externalHeader>
            <hrm-external-header></hrm-external-header>
        </ng-template>  -->       
        <div class=" d-flex flex-row ">
            <div class="d-flex flex-row">
                <app-navigation class="shadow" *ngIf="!showExternalHeader"></app-navigation>
            </div>
            <div class="d-flex flex-column main-body">
                <div class="main-container">
                    <div>
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>